// function to generate label for the bar chart x-axis (0-24Uhr)
import { getClassColor, getPtClass, getPtClassName } from "./publicTransportClasses";

// function to format departure information object for plotting stacked bar chart with groups
function formatData(infoObj) {
    const datasets = [];
    const hinfahrts = infoObj["numberOfDepartures"]["H"];
    for (const [ptType, arr] of Object.entries(hinfahrts)) {
        datasets.push(
            {
                label: "Hinfahrt - " + getPtClassName(ptType),
                data: arr,
                borderWidth: 1,
                stack: "Hinfahrt",
                backgroundColor: getClassColor(ptType, "hinfahrt"),
            }
        );
    }
    const rueckfahrts = infoObj["numberOfDepartures"]["R"];
    for (const [ptType, arr] of Object.entries(rueckfahrts)) {
        datasets.push(
            {
                label: "Rückfahrt - " + getPtClassName(ptType),
                data: arr,
                borderWidth: 1,
                stack: "Rückfahrt",
                backgroundColor: getClassColor(ptType, "rueckfahrt"),
            }
        );
    }
    return datasets;
}

/* function to formart afterLabel texts in the bar chart tooltips:
 * it breaks down the direction list into chunks, combine elements of each chunk as strings,
 * and stores these string chunks in a list. Each list element is displayed as a line in the tooltip.
 * example output --> ["Salzburg süd, Untersbergbahn, Birkensiedlung", "Josefiau, xxx, xxx", "xxx"]
 * */

function formatDirectionDetails(directionArr) {
    let afterLabelArr = [];
    const chunkSize = 3;
    for (let i = 0; i < directionArr.length; i += chunkSize) {
        const chunk = directionArr.slice(i, i + chunkSize);
        let detailInfo = "";
        chunk.forEach(e => detailInfo += e + ", ");
        afterLabelArr.push(detailInfo.slice(0, -2));
    }
    return afterLabelArr;
}

// get label for the bar chart
function getBarChartLabel(hourSequence) {
    let zeroUhrIdx = hourSequence.indexOf(0);
    return hourSequence.map((e, idx) => {
        // when the 0Uhr is not the first hour of the sequence, it means that this OUhr is already in the next day
        if (zeroUhrIdx > 0 && idx >= zeroUhrIdx) {
            return e + " Uhr (T+1)";
        } else {
            return e + " Uhr";
        }
    });
}

const departureBarChartData = (infoObj) => {
    return {
        labels: getBarChartLabel(infoObj["hourSequence"]),
        datasets: formatData(infoObj)
    };
};

const departureBarChartOptions = (infoObj) => {
    return {
        interaction: {
            intersect: false,
            mode: "x"
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks:{
                    precision: 0
                }
            }
        },
        layout: {
            padding: {
                bottom: 25
            }
        },
        aspectRatio: 3,
        plugins: {
            title: {
                display: true,
                text: "Abfahrtsinformation (Zahl der Abfahrten)"
            },
            tooltip: {
                position: "nearest",
                callbacks: {
                    afterLabel: function(context) {
                        let index = context.parsed.x;
                        let ptClass = getPtClass(context.dataset.label);
                        let direction = context.dataset.stack.charAt(0);
                        let directionArr = infoObj["directionInfo"][direction][ptClass][index];
                        return formatDirectionDetails(directionArr);
                    }
                }
            }
        }
    };
};

export { departureBarChartData, departureBarChartOptions };
